<template>
  <div class="h-screen">
    <div :class="[`bg-${$route.meta.background}`]">
      <div class="hidden lg:flex justify-between">
        <img src="@/assets/images/brand/logo_full.svg" alt="Early Stage Online" class="p-8" />
        <router-link
          :to="{ name: 'Main.Homeworks', params: { kidId: $route.params.kidId } }"
          class="p-5 no-underline text-4xl"
        >
          &times;
        </router-link>
      </div>
      <div class="lg:hidden flex items-center">
        <img
          src="@/assets/images/icons/right-arrow.svg"
          alt="back"
          class="p-3 cursor-pointer absolute"

          @click="routerPush({ name: 'Main.Homeworks', params: { kidId: $route.params.kidId } })"
        />

        <img src="@/assets/images/brand/logo.svg" alt="Early Stage Online" class="p-8 m-auto" />
      </div>
    </div>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'HomeworkLayout',
};
</script>
